import {registerPlugin} from '@capacitor/core';
export interface SpecialAccessPlugin {
	getMessage(): Promise<{message: string}>;
	checkPermissions(): Promise<{ isExternalStorageManager: boolean}>;
	getPermissions(): Promise<{ getExtStoragePermissions: boolean}>;
	getAppDetailPermissions(): Promise<{ getAppDetailPermissions: boolean}>;
	getFileMetaData(uri: string): Promise<{ getFileMetaData: any}>;
}
const cmSpecialAccess = registerPlugin<SpecialAccessPlugin>('CMSpecialAccess');
export default cmSpecialAccess;
